import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import {
  GuaranteesBusinessCategory,
  GuaranteesContractName,
  GuaranteesCoverageType,
  GuaranteesMainDealConditionsFieldName,
  GuaranteesMainDealConditionsStatus,
  GuaranteesRiskApprovalStatus,
  type TGuaranteesMainDealConditionsValues,
} from '~/store/guarantees/types.ts';

export const MANAGER_APPROVAL_LETTER_TEXT = {
  sectionStep: '04',
  sectionTitle: 'Лист-погодження',
  sectionDescription: 'Перегляньте сформований лист-погодження.',
  openButton: 'Відкрити PDF в новій вкладці',
  coverageTypeLabel: 'Тип покриття',
  coverageTypePlaceholder: 'Оберіть тип покриття',
  previewTitle: 'Лист-погодження',
  submitButton: 'Підтвердити',
  submitSuccessMessage: 'Лист-погодження успішно підтверджено',
  successCloseButton: 'Закрити',
} as const;

export const MANAGER_APPROVAL_LETTER_COVERED_COVERAGE_TYPE_OPTION: TAutocompleteOption = {
  label: 'Покрита',
  value: GuaranteesCoverageType.COVERED,
};

export const MANAGER_APPROVAL_LETTER_COVERAGE_TYPE_OPTIONS: TAutocompleteOption[] = [
  MANAGER_APPROVAL_LETTER_COVERED_COVERAGE_TYPE_OPTION,
  {
    label: 'Непокрита',
    value: GuaranteesCoverageType.UNCOVERED,
  },
];

export const MANAGER_APPROVAL_LETTER_ACCESS_DENIED_TEXT =
  'У вас немає прав доступу до кроку листа-погодження AM.';

export const MANAGER_APPROVAL_LETTER_LOADING_TEXT = 'Завантажуємо документ...';
export const MANAGER_APPROVAL_LETTER_MISSING_PDF_TEXT =
  'Не вдалося завантажити PDF документ';

export const MANAGER_MAIN_DEAL_CONDITIONS_TEXT = {
  sectionTitle: 'Умови основного договору',
  businessCategoryLabel: 'Категорія контрагента',
  riskApprovalStatusLabel: 'Операція погоджена ризиками',
  riskApprovalStatusPlaceholder: 'Оберіть статус погодження',
  contractNameLabel: 'Назва договору',
  contractNamePlaceholder: 'Оберіть назву договору',
  maxGuaranteeTermDaysLabel: 'Максимальний термін гарантійної операції',
  mainDealConditionsStatusLabel: 'Умови ГД підтверджено',
  mainDealConditionsStatusPlaceholder: 'Оберіть статус умов ГД',
  normativeCoverageRatioLabel: 'Коефіцієнт покриття згідно договору',
  loadingText: 'Завантаження умов основного договору...',
  saveButton: 'Зберегти умови основного договору',
} as const;

export const MAIN_DEAL_CONDITIONS_BUSINESS_CATEGORY_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesBusinessCategory }
> = [
  { value: GuaranteesBusinessCategory.CORPORATE, label: 'Корпоративний бізнес' },
  { value: GuaranteesBusinessCategory.SMB, label: 'Малий та середній бізнес' },
];

export const MAIN_DEAL_CONDITIONS_RISK_APPROVAL_STATUS_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesRiskApprovalStatus }
> = [
  { value: GuaranteesRiskApprovalStatus.APPROVED, label: 'Погоджено ризиками' },
  { value: GuaranteesRiskApprovalStatus.NOT_APPROVED, label: 'Не погоджено ризиками' },
];

export const MAIN_DEAL_CONDITIONS_CONTRACT_NAME_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesContractName }
> = [
  {
    value: GuaranteesContractName.GENERAL_GUARANTEE_AGREEMENT,
    label:
      'Генеральний договір про надання гарантій / контргарантій / резервних акредитивів',
  },
  {
    value: GuaranteesContractName.ADDITIONAL_GUARANTEE_AGREEMENT,
    label:
      'Додатковий договір про надання гарантій / контргарантій / резервних акредитивів',
  },
  {
    value: GuaranteesContractName.GUARANTEE_AGREEMENT,
    label: 'Договір про надання гарантії / контргарантій / резервних акредитивів',
  },
];

export const MAIN_DEAL_CONDITIONS_STATUS_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesMainDealConditionsStatus }
> = [
  {
    value: GuaranteesMainDealConditionsStatus.COMPLIED,
    label: 'Умови ГД підтверджено',
  },
  {
    value: GuaranteesMainDealConditionsStatus.NOT_COMPLIED,
    label: 'Умови ГД не підтверджено',
  },
];

export const MAIN_DEAL_CONDITIONS_REQUIRED_FIELDS: Array<
  keyof TGuaranteesMainDealConditionsValues
> = [
  GuaranteesMainDealConditionsFieldName.RiskApprovalStatus,
  GuaranteesMainDealConditionsFieldName.ContractName,
  GuaranteesMainDealConditionsFieldName.MaxGuaranteeTermDays,
  GuaranteesMainDealConditionsFieldName.MainDealConditionsStatus,
  GuaranteesMainDealConditionsFieldName.NormativeCoverageRatio,
];

export const MANAGER_APPROVAL_LETTER_GET_STARTED_PATH =
  '/guarantees/administrator/get-started';
export const MANAGER_APPROVAL_LETTER_TASKS_PATH = '/tasks';
